import { db } from "@/firebase/init.js";
import {
  collection,
  query,
  orderBy,
  doc,
  getDocs,
  getDoc,
  setDoc,
  deleteDoc,
  updateDoc,
  increment,
  arrayUnion,
  arrayRemove,
  where,
} from "firebase/firestore";

const classesModule = {
  namespaced: true,
  state: {
    classesList: [],
    updateClass: {},
    StudentIds: [],
    StudentsOfClass: [],
    isLoading: true,
    isFirstLoad: true,
  },
  getters: {
    getClasses: (state) => state.classesList,
    getUpdateClass: (state) => state.updateClass,
    getStudentIds: (state) => state.StudentIds,
    getStudentsOfClass: (state) => state.StudentsOfClass,
    isLoading: (state) => state.isLoading,
    isFirstLoad: (state) => state.isFirstLoad,
  },
  mutations: {
    // Loading
    setLoading: (state, payload) => {
      state.isLoading = payload;
    },

    // First load
    setFirstLoad: (state, payload) => {
      state.isFirstLoad = payload;
    },

    // Get All Classes
    setClasses: (state, payload) => {
      state.classesList = payload;
    },

    // Get All Students of Class
    setStudentsOfClass: (state, payload) => {
      state.StudentsOfClass = payload;
    },

    // Get All Ids in SubCollection
    setStudentsIds: (state, payload) => {
      state.StudentIds = payload;
    },

    // Add Class
    setAddClass: (state, payload) => {
      if (state.classesList.length > 0) state.classesList.unshift(payload);
      else state.classesList = [payload];
    },

    // get Class by id
    getClassById: (state, payload) => {
      state.updateClass = payload;
    },

    // Update Class
    updateClass: (state, payload) => {
      const findIndex = state.classesList.findIndex(
        (classs) => classs.class_id == payload.class_id
      );
      state.classesList[findIndex] = payload;
    },

    // Delete Class
    deleteClass: (state, payload) => {
      const findIndex = state.classesList.findIndex(
        (classs) => classs.class_id == payload
      );
      state.classesList.splice(findIndex, 1);
    },

    // Students Counter
    incrementCount: (state, payload) => {
      console.log(payload);

      payload.forEach((classId) => {
        const findIndex = state.classesList.findIndex(
          (classInfo) => classInfo.class_id == classId
        );
        console.log(findIndex);
        console.log(state.classesList[findIndex]);

        state.classesList[findIndex].students_count += 1;
      });
    },
    decrementCount: (state, payload) => {
      payload.forEach((classId) => {
        const findIndex = state.classesList.findIndex(
          (classInfo) => classInfo.class_id == classId
        );
        state.classesList[findIndex].students_count -= 1;
      });
    },

    // On Select
    incrementMultiCount: (state, payload) => {
      const findIndex = state.classesList.findIndex(
        (classInfo) => classInfo.class_id == payload.class_id
      );
      state.classesList[findIndex].students_count += payload.students_count;
    },
    decrementMultiCount: (state, payload) => {
      const findIndex = state.classesList.findIndex(
        (classInfo) => classInfo.class_id == payload.class_id
      );
      state.classesList[findIndex].students_count -= payload.students_count;
    },
  },
  actions: {
    // Get All Classes
    async fetchClasses({ commit }) {
      commit("setLoading", true);
      commit("setFirstLoad", true);
      const classes = await getDocs(
        query(collection(db, "Classes"), orderBy("created_date", "desc"))
      );
      let classesList = [];
      if (!classes.empty) {
        classes.forEach((doc) => {
          classesList.push({ ...doc.data(), class_id: doc.id });
        });
      } else {
        console.log("No Classes found");
        classesList = false;
      }
      commit("setClasses", classesList);
      commit("setLoading", false);
      commit("setFirstLoad", false);
      return classes;
    },

    async addClassFromClasses({ commit }, payload) {
      const documentReference = doc(collection(db, "Classes"));
      const classes = {
        ...payload,
        class_id: documentReference.id,
        created_date: new Date(),
      };
      await setDoc(documentReference, classes);
      commit("setAddClass", classes);
    },

    // Add Class
    async addClass({ commit }, payload) {
      console.log(payload);
      const documentReference = doc(collection(db, "Classes"));
      const classes = {
        ...payload,
        class_id: documentReference.id,
        created_date: new Date(),
      };
      await setDoc(documentReference, classes);
      console.log(this.state.groupsModule.classesOfGroups);

      this.state.groupsModule.classesOfGroups.push(classes);
      commit("setAddClass", classes);
    },

    // get Class by id
    async getClassById({ commit }, payload) {
      commit("setLoading", false);
      let classSelect = await getDoc(doc(db, "Classes", payload));
      console.log(classSelect.data());
      commit("getClassById", classSelect.data());
    },

    // get Students in Class
    async getStudents({ commit }, payload) {
      commit("setLoading", true);
      const students = await getDocs(
        query(
          collection(db, "Students"),
          where("classes", "array-contains-any", [payload])
        )
      );
      let studentsList = [];
      if (!students.empty) {
        students.forEach((doc) => {
          studentsList.push({ ...doc.data(), class_id: doc.id });
        });
      } else {
        console.log("No Student found in Class");
        studentsList = false;
      }
      commit("setStudentsOfClass", studentsList);
      commit("setLoading", false);
      return studentsList;
    },

    // Get Sub Collection Students
    async getSubCollectionIds({ commit }, payload) {
      commit("setLoading", false);
      let students_ids;
      await getDoc(doc(db, `Classes/${payload}/Students`, "students"))
        .then((doc) => {
          students_ids = doc.data().students; // state
        })
        .catch((error) => {
          students_ids = false;
          console.log(error);
        });
      commit("setStudentsIds", students_ids);
      console.log("Module", students_ids);
      return students_ids;
    },

    // Add student collection to class
    async addStudentToClass({ commit }, payload) {
      // let students;
      for (let i = 0; i < payload.classes.length; i++) {
        setDoc(
          doc(db, `Classes/${payload.classes[i]}/Students`, "students"),
          {
            students: arrayUnion(payload.student_id),
          },
          { merge: true }
        );
        commit("setFirstLoad", false);
      }
    },
    // Remove student collection from class
    async removeStudentFromClass({ commit }, payload) {
      for (let i = 0; i < payload.classes.length; i++) {
        setDoc(
          doc(db, `Classes/${payload.classes[i]}/Students`, "students"),
          {
            students: arrayRemove(payload.student_id),
          },
          { merge: true }
        );
        commit("setFirstLoad", false);
      }
    },

    async deleteStudentFromClass({ commit }, payload) {
      console.log(payload);
      setDoc(
        doc(db, `Classes/${payload.class_id}/Students`, "students"),
        {
          students: arrayRemove(payload.student_id),
        },
        { merge: true }
      );
      commit("setFirstLoad", false);
    },

    // Update Class
    async updateClass({ commit }, payload) {
      updateDoc(doc(db, "Classes", payload.class_id), payload);
      commit("updateClass", payload);
    },

    // Delete Class
    async deleteClass({ commit }, payload) {
      deleteDoc(doc(db, "Classes", payload));
      commit("deleteClass", payload);
    },

    // Increase Count of Students in Class
    async increaseCount({ commit }, payload) {
      for (let i = 0; i < payload.length; i++) {
        updateDoc(doc(db, "Classes", payload[i]), {
          students_count: increment(1),
        });
      }

      console.log(payload);
      commit("incrementCount", payload);
    },

    // Decrease Count of Students in Class
    async decreaseCount({ commit }, payload) {
      for (let i = 0; i < payload.length; i++) {
        updateDoc(doc(db, "Classes", payload[i]), {
          students_count: increment(-1),
        });
      }
      commit("decrementCount", payload);
    },

    // On Select
    // Add student collection to class
    async addStudentsToClass({ commit }, payload) {
      // let students;
      payload.classes.forEach((classID) => {
        updateDoc(
          doc(db, `Classes/${classID}/Students`, "students"),
          {
            students: arrayUnion(...payload.students),
          },
          { merge: true }
        );
      });
      commit("setFirstLoad", false);
    },

    // Delete Multi select Students from class
    async removeMultiStudentsFromClass({ commit }, payload) {
      updateDoc(
        doc(db, `Classes/${payload.classID}/Students`, "students"),
        {
          students: arrayRemove(...payload.studentsIDs),
        },
        { merge: true }
      );
      commit("setFirstLoad", false);
    },

    async removeMultiClassesFromStudents({ commit }, payload) {
      for (let i = 0; i < payload.students.length; i++) {
        updateDoc(
          doc(db, `Students/${payload.students[i]}`),
          {
            classes: arrayRemove(payload.classes),
            fullClassesInfo: arrayRemove(payload.fullClassesInfo),
          },
          { merge: true }
        );
      }
      commit("setFirstLoad", false);
    },

    async decreaseMultiStudents({ commit }, payload) {
      updateDoc(doc(db, "Classes", payload.class_id), {
        students_count: increment(-payload.students_count),
      });
      commit("decrementMultiCount", payload);
    },

    async increaseMultiStudents({ commit }, payload) {
      console.log(payload);
      updateDoc(doc(db, "Classes", payload.class_id), {
        students_count: increment(payload.students_count),
      });
      commit("incrementMultiCount", payload);
    },

    async addStudentToNewClass({ commit }, payload) {
      updateDoc(
        doc(db, `Classes/${payload.class_id}/Students`, "students"),
        {
          students: arrayUnion(...payload.students),
        },
        { merge: true }
      );
      commit("setFirstLoad", false);
    },
  },
};

export default classesModule;
